import { Action, combineReducers } from '@ngrx/store';

import {
  _CLEAR,
  CREATE_PRODUCT,
  CREATE_SUBASSEMBLY,
  DELETE_PRODUCT,
  DELETE_SUBASSEMBLY,
  GET_PRODUCT,
  GET_SUBASSEMBLIES,
  GET_PRODUCTS,
  UPDATE_PRODUCT,
  UPDATE_SUBASSEMBLY,
  UPDATE_PRODUCTS,
  SET_PRODUCT_LIST_VIEW,
  RESET_PRODUCT_DETAILS_VIEW,
  SET_PRODUCT_DETAILS_VIEW
} from '../actions';
import { Product } from 'app/models';

const initialProductsState = {
  clonePrompt   : <string>'',
  renamePrompt  : <string>'',
  newProductName: <string>'',
  productName   : <string>'',
  loading       : <boolean>false
};

const initialProductDetailsState = {
  sku          : <string>null,
  name         : <string>'',
  editExisting : <boolean>false,
  productHeader: <string>'',
  loading      : <boolean>false,
  submitted    : <boolean>false
}

const initialProductSubAssemblyListState = {
  productSubAssemblies: <any>[]
};

export const productListReducer = (state = [], action: Action) => {
  switch (action.type) {
    case _CLEAR:
      return [];
    case CREATE_PRODUCT:
      const match = state.find(product => action.payload.product && product.sku === action.payload.product.sku);
      return !match
        ? [ ...state, action.payload.product ].sort(sortProducts)
        : state;
    case DELETE_PRODUCT:
      return state.filter(product => product.sku !== action.payload.sku);
    case GET_PRODUCTS:
      return [ ...action.payload.products ].sort(sortProducts);
    case UPDATE_PRODUCT:
      return state.map(product => {
        return product.sku === action.payload.sku
          ? updateProduct(product, action.payload.diffList)
          : product;
      });
    case UPDATE_PRODUCTS:
      return state.map(stateProduct => {
        const match = action.payload.products.find(product => product.sku === stateProduct.sku);
        return !match ? stateProduct : match;
      });
    default:
      return state;
  }
}

function updateProduct(product: Product, diffList): any {
  diffList.forEach(diff => {
      product[diff.path] = diff.newVal; 
  });
  return product;
}

export const productListViewReducer = (state = initialProductsState, action: Action) => {
  switch (action.type) {
    case SET_PRODUCT_LIST_VIEW:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}

export const productDetailsViewReducer = (state = initialProductDetailsState, action: Action) => {
  switch (action.type) {
    case RESET_PRODUCT_DETAILS_VIEW:
      return Object.assign({}, state, initialProductDetailsState);
    case SET_PRODUCT_DETAILS_VIEW:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}

export const productSubAssemblyListReducer = (state = [], action: Action) => {
  switch (action.type) {
    case _CLEAR:
      return [];
    case CREATE_SUBASSEMBLY:
      return [ ...state, action.payload.productSubAssembly ];
    case DELETE_SUBASSEMBLY:
      return state.filter(subAssembly => subAssembly.sku !== action.payload.sku);
    case GET_SUBASSEMBLIES:
      return [ ...action.payload.productSubAssemblies ];
    case UPDATE_SUBASSEMBLY:
      return state.map(subAssembly => {
        return subAssembly.sku === action.payload.subAssembly.sku
          ? action.payload.subAssembly
          : subAssembly;
      });
    default:
      return state;
  }
}

function sortProducts(product1, product2): number {
  const product1Name = (product1.name || '').toLowerCase();
  const product2Name = (product2.name || '').toLowerCase();

  if (product1Name < product2Name) return -1;
  else if (product1Name > product2Name) return 1;
  else return 0;
}

export const productReducers = combineReducers({
  productList: productListReducer,
  productListView: productListViewReducer,
  productDetailsView: productDetailsViewReducer,
  productSubAssemblies: productSubAssemblyListReducer
});



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/ngrx/reducers/products.ts